/**
 * Utilities for persisting which per-page "Fashionapps guide" help cards have
 * been dismissed (Pomiń) and whether all of them were dismissed at once
 * (Gotowe), in localStorage.
 */
const PAGE_GUIDES_DISMISSED_KEY = 'page_guides_dismissed';
const DEFAULT_STATE = {
    dismissedPages: [],
    allDismissed: false,
};
export const loadPageGuidesDismissed = () => {
    try {
        const stored = localStorage.getItem(PAGE_GUIDES_DISMISSED_KEY);
        return stored ? Object.assign(Object.assign({}, DEFAULT_STATE), JSON.parse(stored)) : Object.assign({}, DEFAULT_STATE);
    }
    catch (error) {
        console.warn('Failed to load page guides dismissed state from localStorage:', error);
        return Object.assign({}, DEFAULT_STATE);
    }
};
/**
 * Mark a single page's guide card as dismissed (Pomiń) and persist it.
 */
export const saveDismissedPageGuide = (pageKey) => {
    try {
        const current = loadPageGuidesDismissed();
        const next = Object.assign(Object.assign({}, current), { dismissedPages: current.dismissedPages.includes(pageKey)
                ? current.dismissedPages
                : [...current.dismissedPages, pageKey] });
        localStorage.setItem(PAGE_GUIDES_DISMISSED_KEY, JSON.stringify(next));
        return next;
    }
    catch (error) {
        console.warn('Failed to save dismissed page guide to localStorage:', error);
        return loadPageGuidesDismissed();
    }
};
/**
 * Mark every page's guide card as dismissed (Gotowe) and persist it.
 */
export const saveAllPageGuidesDismissed = () => {
    try {
        const current = loadPageGuidesDismissed();
        const next = Object.assign(Object.assign({}, current), { allDismissed: true });
        localStorage.setItem(PAGE_GUIDES_DISMISSED_KEY, JSON.stringify(next));
        return next;
    }
    catch (error) {
        console.warn('Failed to save all page guides dismissed to localStorage:', error);
        return loadPageGuidesDismissed();
    }
};
